import React from 'react'
import { Link, LinkProps, Navigate, useLocation } from 'react-router-dom'

interface NavigateWithParamsProps {
    to: string
    replace?: boolean
    state?: any
}

export const NavigateWithParams = ({ to, replace, state }: NavigateWithParamsProps) => {
    const location = useLocation()
    const targetPath = to.includes('?') 
        ? to 
        : (location.search ? `${to}${location.search}` : to)

    return <Navigate to={targetPath} replace={replace} state={state} />
}

export const LinkWithParams = ({ to, ...props }: LinkProps) => {
    const location = useLocation()
    const targetPath = (typeof to === 'string' && to.includes('?'))
        ? to 
        : (location.search ? `${to}${location.search}` : to)
        
    return <Link to={targetPath} {...props} />
}
